import withSearch from '../core/withSearch'
import Facet from './Facet'

function FacetContainer({ addFacet, removeFacet, options, field, view, color }) {
    const View = view || Facet

    return View({
        label: field,
        options,
        onSelect: value => {
            addFacet(field, value)
        },
        onRemove: value => {
            removeFacet(field, value)
        },
    })
}

export default withSearch(({ addFacet, removeFacet }) => ({
    addFacet,
    removeFacet,
}))(FacetContainer)



